import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Container } from "reactstrap";
import { useSocialPostCore } from "../../../../cores/socialPost";
import { SocialProviderId } from "../../../../cores/socialPost/config";
import { IconMapper } from "../selector/SocialPostSelector";
import { FacebookPostPreview } from "./FacebookPostPreview";
import { InstagramPostPreview } from "./InstagramPostPreview";
import { LinkedInPostPreview } from "./LinkedInPostPreview";
import { TwitterPostPreview } from "./TwitterPostPreview";
import { TiktokPostPreview } from "./TiktokPostPreview";
import "./SocialPostPreview.scss";

export const SocialPostPreview = () => {
  const { postErrors, socialProviders } = useSocialPostCore();
  const [previewId, setPreviewId] = useState<string>("");
  useEffect(() => {
    if ((socialProviders as any[]).length === 0) setPreviewId("");
    if ((socialProviders as any[]).length > 0)
      if (
        !previewId ||
        !(socialProviders as any[]).filter((sp: any) => sp.id === previewId).length
      )
        setPreviewId((socialProviders as any[])[0].id);
  }, [previewId, socialProviders]);

  const showIcon = useCallback(
    (id: string) => {
      const error = (postErrors as any[]).filter(
        ({ socialProviderId }: any) => socialProviderId === id
      );
      console.log({ error });
      return error.length > 0 ? (
        <FontAwesomeIcon
          icon={["fas", "exclamation-circle"]}
          size="xs"
          color="red"
          className="position-absolute"
          style={{ marginLeft: "22px", marginTop: "20px", zIndex: 100 }}
        />
      ) : null;
    },
    [postErrors]
  );

  const showPreview = useMemo(() => {
    switch (previewId) {
      case SocialProviderId.Facebook:
        return <FacebookPostPreview />;
      case SocialProviderId.Twitter:
        return <TwitterPostPreview />;
      case SocialProviderId.LinkedIn:
        return <LinkedInPostPreview />;
      case SocialProviderId.LinkedInBusiness:
        return <LinkedInPostPreview business />;
      case SocialProviderId.Instagram:
        return <InstagramPostPreview />;
      case SocialProviderId.TikTok:
        return <TiktokPostPreview />;
      default:
        return null;
    }
  }, [previewId]);

  // Si no hay redes sociales seleccionadas, mostrar mensaje
  if ((socialProviders as any[]).length === 0) {
    return (
      <Container
        className="h-100 overflow-auto pb-3 mb-1 d-flex align-items-center justify-content-center"
        style={{
          maxHeight: "700px",
        }}
      >
        <div className="text-center">
          <h5 className="text-muted">Selecciona una red social para ver la vista previa</h5>
        </div>
      </Container>
    );
  }

  return (
    <Container
      className="h-100 overflow-auto pb-3 mb-1"
      style={{
        maxHeight: "700px",
      }}
    >
      {/* Selector de redes sociales - solo se muestra si hay más de una */}
      {(socialProviders as any[]).length > 1 && (
        <div className="preview-switch-container">
          <div className="preview-switch">
            {(socialProviders as any[]).sort().map(({ id }: any) => (
              <button
                key={id}
                className={`preview-switch-button ${id === previewId ? 'active' : ''}`}
                onClick={() => setPreviewId(id)}
              >
                <div className="switch-icon">
                  {showIcon(id)}
                  {_.isFunction(IconMapper[id]) &&
                    IconMapper[id]({ active: id === previewId, size: "1x" })}
                </div>
                <div className="switch-label">{id}</div>
              </button>
            ))}
          </div>
        </div>
      )}
      {showPreview}
    </Container>
  );
};
